import { APIClient } from '@/APIClient';

export const authApiClient = {
  get: async <T>(url: string, params: Record<string, any> = {}, token?: string): Promise<T> => {
    return APIClient.makeAPICall('GET', url, { queryParams: params });
  },
  post: async <T>(url: string, data: any = {}, token?: string): Promise<T> => {
    return APIClient.makeAPICall('POST', url, { body: data });
  },
  patch: async <T>(url: string, data: any = {}, token?: string): Promise<T> => {
    return APIClient.makeAPICall('PATCH', url, { body: data });
  },
  put: async <T>(url: string, data: any = {}, token?: string): Promise<T> => {
    return APIClient.makeAPICall('PUT', url, { body: data });
  },
  delete: async <T>(url: string, token?: string, body?: any): Promise<T> => {
    return APIClient.makeAPICall('DELETE', url, body ? { body } : undefined);
  }
};
